import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-form-section-v2',
    templateUrl: './form-section-v2.component.html',
    styleUrls: ['./form-section-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormSectionV2Component implements OnInit {
  
  @Input() configData;
  @Input() frmGroup;
  isLoading: boolean = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  constructor() { }

  ngOnInit() {
    // console.log(this.frmGroup);
    // console.log(this.configData);
    if(this.configData.validation && this.configData.validation.length)      
      this.fieldValueValidation(this.configData.validation);
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        this.frmGroup.get(this.configData.name)['hidden'] = true;
        this.configData.required = false;                    
        this.frmGroup.get(this.configData.name).clearValidators();
        this.frmGroup.get(this.configData.name).updateValueAndValidity();
      }
    });
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
     this.isLoading = true;
    document.getElementById("overlay").style.display = "block";
    // this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    // this.frmGroup.get(this.configData.name).reset();
    // this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }

  getColsClass(control) {
    let cols = control.cols;
    let visibility = control.visibility;
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    let zeroColumn: boolean = false;
    for (let i = 0; i < cols.length; i++) {
      if(cols[i] === "0")
        colsClass += 'col-' + mediaBreakpoints[i] + '-' + 'zeroColumn' + ' ';
      else
        colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    if (visibility === 'hidden') {
      colsClass += 'hidden';
    }

    // make control half width
    if(control.hasOwnProperty("makeDwarf") && control.makeDwarf){
      colsClass += 'dwarf' + ' ';
    }

    return colsClass;

    // const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    // let colsClass = '';
    // for (let i = 0; i < cols.length; i++) {
    //   colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    // }    
    // if(control && control.hasOwnProperty("makeDwarf") && control.makeDwarf){
    //   colsClass += 'dwarf' + ' ';
    // }
    // return colsClass;
  }
  getFormTableControls() {

    // this.frmGroup.controls.forEach(grp=>{
      // return grp.get(this.configData.name);
      // return this.frmGroup.get(this.configData.name)['controls'];
    // })

    try{
    return this.frmGroup.controls[this.configData.name]['controls'];
  }
    catch{
      console.log(this.configData, this.frmGroup.controls);
    }
  }
}
